import { Localization } from '../../localization/localization';
import { JsFormBeforeSendObject, JsFormResponseHandlerObject } from '../modules/jsFormTypes.js';
import { ErrorToolTip, TooltipDirection } from '../newErrorToolTip';
import { FormHandlers } from '../modules/formHandlers';
import { PopupManager } from '../../popups/popupManager';
import { getUrlToLoginViaToken } from '../../login/getUrlToLoginViaToken';
import { addLoginQueryParams } from '../../utils/url';
import { appendUnityLoginIframe } from '../../utils/landing';
import { CustomJrpcErrResult } from '../modules/jsonRpc/jRpcErrResponse';
import { getHubApi } from '../modules/accountServiceApi/getAccountServiceApi';
import { UserSession } from '../modules/user/userSession';
import { ClientApiErrorCodes } from '@scorewarrior/rubens_web_lib/lib/hub-api/constants/client-api-error-codes';
import {
    Login2FaOtpRequest,
    Login2FaOtpResponse
} from '@scorewarrior/rubens_web_lib/lib/hub-api/protocol/login-2fa-otp-protocol';
import {
    Request2FaOtpRequest
} from '@scorewarrior/rubens_web_lib/lib/hub-api/protocol/request-2fa-otp.protocol';

let otp2FaEmail: string | null = null;

const otp2FaState = {
    allowResendTime: 0,
    isResend: false
};

let otp2FaCountDown: number;

function otp2FaUpdateCounter() {
    const now = new Date().getTime();
    const delta = otp2FaState.allowResendTime ? otp2FaState.allowResendTime - now : 0;
    if (delta < 0) {
        clearInterval(otp2FaCountDown);
        otp2FaDisplayReturnText();
        return;
    }
    otp2FaUpdatePopupText(delta);
}

function otp2FaDisplayReturnText() {
    $('.otp-2fa-resend-info').html(Localization._n('accounting.OTP_window.resend_code'));
    $('.otp-2fa-resend-info a')
        .addClass('popup_link1')
        .on('click', function (e) {
            e.preventDefault();
            resend2FaOtp();
        });
}

function otp2FaUpdatePopupText(delta: number) {
    const SECOND_DELTA_NUMERATOR = 1000 * 60;
    const SECOND_DELTA_DENOMINATOR = 1000;
    const minutes = Math.floor(delta / SECOND_DELTA_NUMERATOR);
    let seconds: number | string = Math.ceil((delta % SECOND_DELTA_NUMERATOR) / SECOND_DELTA_DENOMINATOR);
    if (seconds < 10) {
        seconds = `0${seconds}`;
    }
    let translationKey = '';
    if (otp2FaState.isResend) {
        translationKey = 'accounting.OTP_window.code_resend_resend_code_after';
    } else {
        translationKey = 'accounting.OTP_window.resend_code_after';
    }
    $('.otp-2fa-resend-info').html(Localization._n(
        translationKey,
        {
            minutes: `${minutes}`,
            seconds: `${seconds}`
        }
    ));
}

function otp2FaConfirmCodeSendHandler(data: JsFormBeforeSendObject) {
    const otpValue = $('.pin-input', data.form).toArray()
        .map((input: HTMLInputElement) => input.value)
        .join('');
    if (otpValue.length !== 6) {
        const input = $('.pin-container', data.form);
        let toolTipDirection;

        if (data.form.parents('.forms2').length) {
            toolTipDirection = TooltipDirection.RIGHT;
        } else {
            toolTipDirection = TooltipDirection.LEFT;
        }

        ErrorToolTip.getTooltipElement().showTooltipElement(
            input,
            toolTipDirection,
            Localization._n('otp_request_code.not_full')
        );
        return false;
    }

    return true;
}

function getDisplayableErrorMessage(result: CustomJrpcErrResult|CustomJrpcErrResult['error']|Error): string {
    if (!('error' in result) && !('code' in result)) {
        return Localization._n('errors.common_error');
    }

    let error;

    if ('error' in result) {
        error = result.error;
    } else {
        error = result;
    }

    switch (error?.code) {
        case ClientApiErrorCodes.AUTHORIZATION_FAILED:
            return Localization._n('otp_confirm.wrong_otp');
        default:
            return Localization._n('errors.common_error');
    }
}

function otp2FaConfirmCodeFormAfterHandler(
    data: JsFormResponseHandlerObject<Login2FaOtpResponse | CustomJrpcErrResult>
) {
    const response = data.response;
    let toolTipDirection = TooltipDirection.RIGHT;
    const input = $('.pin-container', data.form);
    if (!('error' in response)) {
        let url = getUrlToLoginViaToken(response?.tether.token, response?.tether.suid);
        url = addLoginQueryParams(url);
        appendUnityLoginIframe(url);
    } else {
        if (data.form.parents('.forms2').length) {
            toolTipDirection = TooltipDirection.RIGHT;
        } else {
            toolTipDirection = TooltipDirection.LEFT;
        }

        ErrorToolTip.getTooltipElement().showTooltipElement(
            input,
            toolTipDirection,
            getDisplayableErrorMessage(response.error)
        );

        input.addClass('error');
    }
}

function otp2FaConfirmCodeFormSendRequest(form: JQuery): Promise<Login2FaOtpResponse | CustomJrpcErrResult> {
    const otpValue = $('.pin-input', form).toArray()
        .map((input: HTMLInputElement) => input.value)
        .join('')
        .toUpperCase();

    if (!otp2FaEmail) {
        window.app.closeAndOpenPopup({
            hideclass: 'popup2',
            alignoff: true,
            id: 'login'
        });

        return Promise.resolve({
            error: {
                message: Localization._n('errors.email_empty'),
                code: ClientApiErrorCodes.EMAIL_EMPTY,
                data: null
            }
        });
    }

    const request: Login2FaOtpRequest = {
        email: otp2FaEmail,
        otp: otpValue,
        locale: window.app.config.locale,
        current_entry_point: window.app.config.current_entry_point
    };

    return getHubApi().login2FaOtp(UserSession.getInstance().getDeviceId(), request);
}

async function resend2FaOtp() {
    $('.pin-input').val('');
    otp2FaState.isResend = true;
    otp2FaState.allowResendTime = new Date().getTime() + 1000 * 30;
    otp2FaUpdateCounter();
    const newOtpRequest: Request2FaOtpRequest = {
        email: otp2FaEmail!,
        locale: window.app.config.locale,
        current_entry_point: window.app.config.current_entry_point
    };
    try {
        await getHubApi().request2FaOtp(
            UserSession.getInstance().getDeviceId(),
            newOtpRequest
        );
        if (otp2FaCountDown) {
            clearInterval(otp2FaCountDown);
        }
        otp2FaCountDown = window.setInterval(() => {
            otp2FaUpdateCounter();
        }, 1000);
    } catch (error) {
        console.error(error);
        otp2FaState.allowResendTime = 0;
        otp2FaUpdateCounter();
        ErrorToolTip.getTooltipElement().showTooltipElement(
            $('.otp-2fa-resend-info:visible a'),
            TooltipDirection.RIGHT,
            getDisplayableErrorMessage(error)
        );
        window.Sentry.captureException(error);
    }

}

export async function open2FaOtpPopup(email: string) {
    otp2FaEmail = email;
    otp2FaState.isResend = false;
    $('.pin-input').val('');

    PopupManager.openSingle('otp_2fa_login');

    const newOtpRequest: Request2FaOtpRequest = {
        email: otp2FaEmail,
        locale: window.app.config.locale,
        current_entry_point: window.app.config.current_entry_point
    };

    try {
        const delay = window.app.config?.otp?.delay ?? 1000 * 60;
        otp2FaState.allowResendTime = new Date().getTime() + delay;
        otp2FaUpdateCounter();
        if (otp2FaCountDown) {
            clearInterval(otp2FaCountDown);
        }
        otp2FaCountDown = window.setInterval(() => {
            otp2FaUpdateCounter();
        }, 1000);
        await getHubApi().request2FaOtp(
            UserSession.getInstance().getDeviceId(),
            newOtpRequest
        );
    } catch (error) {
        ErrorToolTip.getTooltipElement().showTooltipElement(
            $('.otp-2fa-resend-info:visible'),
            TooltipDirection.LEFT,
            getDisplayableErrorMessage(error)
        );
        otp2FaState.allowResendTime = 1;
        otp2FaUpdateCounter();
    }
}

export function init2FaOtpForm() {
    FormHandlers.registerAfterSendHandler('otp_2fa_confirm_code_form_handler', otp2FaConfirmCodeFormAfterHandler);
    FormHandlers.registerBeforeSendHandler('before_otp_2fa_confirm_code', otp2FaConfirmCodeSendHandler);
    FormHandlers.registerSendRequestHandler('otp_2fa_confirm_code_send_request', otp2FaConfirmCodeFormSendRequest);
}
